<div class="flex justify-center">
  <app-media [mediaSource]="modalData.mediaSource" [mediaType]="modalData.mediaType" />
</div>
<div class="flex justify-end" *transloco="let t">
  <button iButton variant="secondary" size="md" (click)="modalRef.close()">{{ t("common.close") }}</button>
</div>
